/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2023
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import _ from 'lodash';
import { IAssociationData } from '../../shared/Utils/EquipmentSpaceMappingAndProperties/DataUtils/DataConverter';
import { lowerCaseNoSpaces } from '../../shared/Utils/EquipmentSpaceMappingAndProperties/DataUtils/DataValidator';

export enum ZLOEquipments {
  VAV = 'VAV',
  VAV2 = 'Variable Air Volume',
  OS = 'OccupancySensor'
  // OS2 = 'OcuupancySensor' // The incorrect Spelling that was populated in DB
}

export enum ZLOElementProperties {
  ZLOState = 'ZLOState',
  ZoneOptimizationSetback = 'ZoneOptimizationSetback'
}

/**
 * Returns Read Data Specific to ZLO, other properties are dropped
 * ElementType VAV 's properties ZLOState, ZoneOptimizationSetback are retained
 * @param conversionData
 * @returns
 */
export const convertAssociationSchemaToZLOOnboardingConfig = (
  conversionData: IAssociationData[]
): IAssociationData[] => {
  const _zloOnboardingConfigData = conversionData.map((d) => {
    const { associations, ...restD } = d;
    const _associations = associations.map((a) => {
      const { properties, ElementType, ...restA } = a;
      return {
        ...restA,
        ElementType,
        // properties only for VAVs
        properties: properties.filter(
          (p) =>
            _.includes(
              [
                ZLOElementProperties.ZLOState,
                ZLOElementProperties.ZoneOptimizationSetback
              ],
              p.propertyKey
            ) &&
            _.includes(
              _.map([ZLOEquipments.VAV, ZLOEquipments.VAV2], lowerCaseNoSpaces),
              lowerCaseNoSpaces(a.ElementType)
            )
        )
      };
    });
    return {
      ...restD,
      // properties: [],
      // allow only equipments defined in ZLOEquipments Object
      associations: _associations.filter((as) =>
        _.includes(
          _.map(ZLOEquipments, lowerCaseNoSpaces),
          lowerCaseNoSpaces(as.ElementType)
        )
      )
    };
  });
  return _zloOnboardingConfigData;
};

// Will have schema conversion from to api request
